import { STO_FLAG } from 'modules/workflows/constants';
import { TimeOfDay } from 'modules/workflows/types';
import { DelayTimeConfig } from './DelayEditor.types';

export const DAY_CONFIG: DelayTimeConfig = {
  min: 0,
  max: 365,
};

export const HOUR_CONFIG: DelayTimeConfig = {
  min: 0,
  max: 23,
};

export const MINUTE_CONFIG: DelayTimeConfig = {
  min: 0,
  max: 59,
};

export const CONTACT_PROPERTY_FIELD = 'user';

export const SCHEDULE_TYPES: Record<string, TimeOfDay['scheduleType']> = {
  PROJECT_TIME_ZONE: 'ProjectTimeZone',
  RECIPIENT_TIME_ZONE: 'RecipientTimeZone',
  OPTIMIZE_SEND_TIME: 'OptimizeSendTime',
  SEND_TIME_OPTIMIZATION: STO_FLAG,
};

export const DELAY_USING_PROPERTY_OPTION_VALUE_SEPARATOR = '-';

export const DELAY_DATA_TYPES = ['user', 'customEvent', 'purchase'];

export const DELAY_TYPES = { PROPERTY: 'property', TIME: 'time' };

export const DELAY_TYPE_OPTIONS = [
  {
    id: `delay-type-${DELAY_TYPES.TIME}`,
    name: 'Period of time',
    value: DELAY_TYPES.TIME,
  },
  {
    id: `delay-type-${DELAY_TYPES.PROPERTY}`,
    name: 'Date-based user/event field',
    value: DELAY_TYPES.PROPERTY,
  },
];

export const DESCRIPTIONS = {
  [DELAY_TYPES.PROPERTY]:
    'Pause users at this tile for a certain amount of time before or after an important date (like their birthday). The delay period starts at a different time for each user.',
  [DELAY_TYPES.TIME]:
    'Pause users at this tile for a set period of time. The delay starts for each user as soon as they enter the tile.',
};
